class GroupRoleSelect extends HTMLSelectElement {
  constructor() {
    super();
    this.template = document.createElement('template');
  }

  // NOT TESTED
  requestUpdate(data){
    this.data = data;

    let options = this.data.map(role => `<option value="${role.id}">${role.display_name}</option>`).join("")
    this.template.innerHTML =`
    <option value=null>Select</option>
    ${options}
    `
    
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.appendChild(this.template.content.cloneNode(true));
    if(this.selectedOptions.length == 0) {
      this.value = "null"
    }
  }

  async connectedCallback() {
    this.data_binder = new DataBinder("/admin/groups/group_role_names.json", true);
    this.data_binder.register(this);
    if(this.data_binder.data) this.requestUpdate(this.data_binder.data);
  }

  disconnectedCallback(){
    this.data_binder.unregister(this);
  }

  getCurrentName() {
    let currentSelected = this.data.filter(function(role) {return role.id == this.value}.bind(this))
    if(currentSelected.length > 0) {
      return currentSelected[0].name;
    } else {
      return null;
    }
    
  }
}

customElements.define('group-role-select', GroupRoleSelect, {extends: 'select'})